var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-card',{attrs:{"title":(_vm.label + " connection"),"backLink":{ name: 'connectionList' }}},[_c('connection-form',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }